import History from '@/pages/requests/HistoryPage.vue'
import Homepage from '@/pages/user/Homepage.vue'
import HomepageKYC from '@/pages/user/HomepageKYC.vue'
import HomepageRTP from '@/pages/user/HomepageRTP.vue'
import RedirectionPageOTP from '@/pages/user/RedirectionPageOTP.vue'
import PageAxepta from '@/pages/axepta/PageAxepta.vue'
import PageLoading from '@/components/common/spinner.vue'

export default [
  {
    path: '/profile/',
    component: require('@/pages/user/CMProfile.vue')
  },
  {
    path: '/profile/edit',
    component: require('@/pages/user/CMProfileEdit.vue')
  },
  {
    path: '/profile/changePassword',
    component: require('@/pages/user/CMChangePassword.vue')
  },
  {
    path: '/login/',
    component: require('@/pages/user/CMLogin.vue')
  },
  {
    path: '/OTP/:email/:otp/:ressource',
    component: RedirectionPageOTP
  },
  {
    path: '/register/:FirstName/:LastName/:Login/:Password',
    component: require('@/pages/user/CMRegister.vue')
  },
  {
    path: '/register/',
    component: require('@/pages/user/CMRegister.vue')
  },
  {
    path: '/home/generic',
    alias: ['/home/'],
    component: Homepage
  },
  {
    path: '/home/KYC',
    component: HomepageKYC
  },
  {
    path: '/home/RTP',
    component: HomepageRTP
  },
  {
    path: '/axepta/',
    component: PageAxepta
  },
  {
    path: '/loading/',
    component: PageLoading
  },
  {
    path: '/history/',
    component: History
  }
]



// WEBPACK FOOTER //
// ./src/routes/user.js